/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Amethyst preset blocks",
  "description": "Controls visibility of Amethyst block categories for camera, environment, mouse, media display, and network tools.",
  "info": [
    {
      "type": "notice",
      "text": "Core Amethyst 3D categories are visible by default. Enable this addon only if you want to hide some of them.",
      "id": "compact"
    },
    {
      "type": "warning",
      "text": "Network blocks can send browser-safe web requests. Only enable them when you know what the project is doing.",
      "id": "network"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Camera blocks",
      "type": "boolean",
      "default": true,
      "id": "camera"
    },
    {
      "dynamic": true,
      "name": "Environment blocks",
      "type": "boolean",
      "default": true,
      "id": "environment"
    },
    {
      "dynamic": true,
      "name": "Mouse blocks",
      "type": "boolean",
      "default": true,
      "id": "mouse"
    },
    {
      "dynamic": true,
      "name": "Media Display blocks",
      "type": "boolean",
      "default": true,
      "id": "media"
    },
    {
      "dynamic": true,
      "name": "Network blocks",
      "type": "boolean",
      "default": true,
      "id": "network"
    }
  ],
  "tags": [
    "editor",
    "amethyst"
  ],
  "enabledByDefault": false,
  "dynamicDisable": true
};
export default manifest;
